import { render, staticRenderFns } from "./VoyageListCardStatus.vue?vue&type=template&id=73f6a97d&"
import script from "./VoyageListCardStatus.vue?vue&type=script&lang=js&"
export * from "./VoyageListCardStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports